export const FETCH_COMPANIES_SUCCESS = 'fetch_companies_success'
export const FETCH_COMPANY_DETAILS_SUCCESS = 'fetch_company_details_success'
export const UPDATE_COMPANY_DETAILS_SUCCESS = 'update_company_details_success'
export const UPDATE_COMPANY_SUCCESS = 'update_company_success'
export const UPDATE_PREFERRED_VEHICLES_SUCCESS = 'update_preferred_vehicles_success'
